// @ts-nocheck
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import SalesPersonInfos, { SalesPersonInfosPresentationProps } from "@store/Library/Components/SalesPersonInfos";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { useSession } from "@toolkit/Framework/Store/Context/ContextHooks";
import React, { FC } from "react";
import { css } from "styled-components";

const enum fields {
    showIcons = "showIcons",
}
export interface ContactUsSalesRepInfosProps extends WidgetProps {
    fields: {
        showIcons: boolean;
    };
}

export interface ContactUsSalesRepInfosStyles {
    salesPersonInfos?: SalesPersonInfosPresentationProps;
}

const contactUsSalesRepInfosStyles: ContactUsSalesRepInfosStyles = {
    salesPersonInfos: {
        overridedStyles: {
            wrapper: {
                css: css`
                    margin-top: ${pxToRem(16)};
                `,
            },
            infoWrapper: {
                css: css`
                    display: flex;
                    flex-direction: column;
                    gap: ${pxToRem(8)};
                `,
            },
            infoText: {
                css: css`
                    display: flex;
                    align-items: center;
                    flex-wrap: wrap;
                `,
            },
        },
    },
};

const styles = contactUsSalesRepInfosStyles;

const ContactUsSalesRepInfos: FC<ContactUsSalesRepInfosProps> = ({ fields }) => {
    const session = useSession();
    const { showIcons } = fields;
    return <SalesPersonInfos session={session} showIcons={showIcons} {...styles.salesPersonInfos} />;
};

const widgetModule: WidgetModule = {
    component: ContactUsSalesRepInfos,
    definition: {
        displayName: "Sales Rep Infos",
        group: "Contact Us",
        fieldDefinitions: [
            {
                name: fields.showIcons,
                displayName: "Show Icons",
                editorTemplate: "CheckboxField",
                defaultValue: false,
                fieldType: "General",
            },
        ],
    },
};

export default widgetModule;
